import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { updateParameterConfiguration } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const updateParamConfig = createApi(
  updateParameterConfiguration,
  "PUT"
);

const updateParameterConfigSlice = createSlice({
  name: "updateParameterConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateParamConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateParamConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateParamConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default updateParameterConfigSlice.reducer;
